module.exports = __webpack_public_path__ + "img/jelen_van_bg_2560_cs.35604a00.png";